import { createContext, useState, useEffect, useRef } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import { mapskey } from '../config';

export const GMContext = createContext({ load: () => {}, loaded: false });

export default function GoogleMapsApiProvider({ children }) {
  const loader = useRef(new Loader({ apiKey: mapskey, language: 'es-mx', libraries: ['places'] }));
  const [loaded, setLoad] = useState(false);

  const load = () => {
    loader.current.load().then(() => {
      setLoad(true);
    });
  };

  useEffect(() => {
    try {
      load();
    } catch (err) {
      setLoad(false);
      console.error(err);
    }
  }, []);

  return <GMContext.Provider value={{ load, loaded }}>{children}</GMContext.Provider>;
}
